/////////////////////////////////////////////////////////////////////
// Copyright (c) Autodesk, Inc. All rights reserved
// Written by Autodesk Inventor Automation team
//
// Permission to use, copy, modify, and distribute this software in
// object code form for any purpose and without fee is hereby granted,
// provided that the above copyright notice appears in all copies and
// that both that copyright notice and the limited warranty and
// restricted rights notice below appear in all supporting
// documentation.
//
// AUTODESK PROVIDES THIS PROGRAM "AS IS" AND WITH ALL FAULTS.
// AUTODESK SPECIFICALLY DISCLAIMS ANY IMPLIED WARRANTY OF
// MERCHANTABILITY OR FITNESS FOR A PARTICULAR USE.  AUTODESK, INC.
// DOES NOT WARRANT THAT THE OPERATION OF THE PROGRAM WILL BE
// UNINTERRUPTED OR ERROR FREE.
/////////////////////////////////////////////////////////////////////

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { loadProfile } from '../actions/profileActions';
import { getProfile, loginFailedShowing } from '../reducers/mainReducer';
import ModalFail from './modalFail';
import { showLoginFailed } from '../actions/uiFlagsActions';
import './toolbar.css';
import authService from '../services/authService';

import TopNav, {
  Logo,
  Interactions,
  Separator
} from '@hig/top-nav';

import styled from 'styled-components';

const CartButton = styled.button`
  position: relative;
  background: var(--primary-color-1, #f47621);
  border: none;
  cursor: pointer;
  padding: 6px 14px;
  margin-right: 12px;
  font-size: 13px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 6px;
  color: #fff;
  border-radius: 4px;
  transition: opacity 0.2s;
  &:hover {
    opacity: 0.85;
  }
`;

const CartBadge = styled.span`
  background: #fff;
  color: var(--primary-color-1, #f47621);
  font-size: 11px;
  font-weight: 700;
  padding: 1px 6px;
  border-radius: 10px;
  min-width: 18px;
  text-align: center;
`;

const PlaceCenterContainer = styled.div`
  align-items: center;
  display: flex;
`;

export class Toolbar extends Component {
  constructor(props) {
    super(props);
    this.handleSignOut = this.handleSignOut.bind(this);
  }

  componentDidMount() {
    this.props.loadProfile();
  }

  onLoginFailedCloseClick() {
    this.props.showLoginFailed(false);
    window.location.reload();
  }

  handleSignOut() {
    authService.logout();
    window.location.reload();
  }

  render() {
    const user = authService.getCurrentUser();
    const userName = user ? user.firstName + ' ' + user.lastName : this.props.isAnonymous ? 'Guest' : 'User';

    return (
      <div>
        <TopNav
          logo={
            <Logo link="/" label="ConfigSelect.com">
              <PlaceCenterContainer>
                <span style={{ fontSize: '18px', fontWeight: 'bold', color: 'var(--primary-color-1)' }}>ConfigSelect.com</span>
              </PlaceCenterContainer>
            </Logo>
          }
          rightActions={
            <React.Fragment>
              <PlaceCenterContainer>
                {this.props.children}
              </PlaceCenterContainer>
              <Interactions>
                <Separator />
                <div style={{ display: 'flex', alignItems: 'center', marginRight: '15px' }}>
                  {this.props.onCartClick && (
                    <CartButton onClick={this.props.onCartClick} title="Quote Folder">
                      Quote Folder
                      {this.props.cartCount > 0 && (
                        <CartBadge>{this.props.cartCount}</CartBadge>
                      )}
                    </CartButton>
                  )}
                  <span style={{ color: '#333', marginRight: '15px', fontSize: '14px', fontWeight: '500' }}>
                    {userName}
                  </span>
                  {this.props.isAnonymous ? (
                    <a
                      href="/login"
                      style={{
                        background: 'var(--primary-color-1)',
                        border: 'none',
                        color: '#fff',
                        padding: '8px 16px',
                        borderRadius: '4px',
                        cursor: 'pointer',
                        fontSize: '13px',
                        fontWeight: '500',
                        textDecoration: 'none'
                      }}
                    >
                      Sign In
                    </a>
                  ) : (
                    <button
                      onClick={this.handleSignOut}
                      style={{
                        background: 'var(--primary-color-1)',
                        border: 'none',
                        color: '#fff',
                        padding: '8px 16px',
                        borderRadius: '4px',
                        cursor: 'pointer',
                        fontSize: '13px',
                        fontWeight: '500'
                      }}
                    >
                      Sign Out
                    </button>
                  )}
                </div>
              </Interactions>
            </React.Fragment>
          }
        />
        {this.props.loginFailedShowing &&
          <ModalFail
              open={this.props.loginFailedShowing}
              title="Login Failed"
              label="Access to this site is by invitation only. Your email is not authorized."
              onClose={() => this.onLoginFailedCloseClick()}/>
        }
        <iframe id="hiddenLogoutFrame" title="logout" style={{display: 'none'}} />
      </div>
    );
  }
}

/* istanbul ignore next */
export default connect(function (store) {
  return {
    profile: getProfile(store),
    loginFailedShowing: loginFailedShowing(store)
  };
}, { loadProfile, showLoginFailed })(Toolbar);